var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"ds-menu",class:[
    _vm.inverse && 'ds-menu-inverse',
    _vm.navbar && 'ds-menu-navbar'
  ]},[_c('ul',{staticClass:"ds-menu-list"},[_vm._t("default",[_vm._l((_vm.routes),function(route,index){return _vm._t(route.name,[_vm._t("menuitem",[_c('ds-menu-item',{key:route.path ? route.path : index,attrs:{"route":route}})],{"route":route})],{"route":route,"parents":[]})})])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }